import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"

import { Row, Col, Alert, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, apiError, socialLogin } from "../../store/actions"

// import images
import logo from "../../assets/images/sus-plan/logo.jpg"
// import logo from "../../assets/images/sus-plan/logo.png"
// import logo from "../../assets/images/supplychain/logo.jpg"
import * as Config from "../../config"
import * as CHelper from "../../helpers/custom_helper"
import Axios from "../../helpers/axios_helper"
import * as Session from "../../helpers/session_helper"
import { useLocation,useHistory } from 'react-router-dom';
import queryString from 'query-string';

const Login = (props) => { 

  const location = useLocation();
  const queryParams = queryString.parse(location.search);

  const history = useHistory()
  const [notification, setNotification] = useState(false);
  const [username, setUsername] = useState(false);
  const [password, setPassWord] = useState(false);

  
  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  useEffect(()=>{
    try {
      if(queryParams.requestData){
        // setUrlRequestdata(props.requestData);
        var urlData = decodeURIComponent(queryParams.requestData);
        urlData = CHelper.decryptData(queryParams.requestData);
        urlData = JSON.parse(urlData);
        Session.setSession(urlData);
        const data = Session.getUser()
        if (data.role_code == '444' || data.role_code=='333') {
          // history.push('/course?page=instructors')
          history.push('/course?page=dashboard')
        }
        else{
          history.push('/');
        }
      }
      if(queryParams.user){
        setUsername(queryParams.user);
      }
      if(queryParams.pass){
        setPassWord(queryParams.pass);
      }
    } catch (error) {
      Session.removeSession();
      console.error(error)
    }
    
  },[queryParams])

  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    window.sLoader();
    await Axios.post("/auth/login", values)
    .then(function (response) {
      if(response.data.status===200){
        Session.setSession(response.data);
        const data = Session.getUser()
        if (data.role_code == '444' || data.role_code=='333') {
          history.push('/course?page=dashboard')
        }
        else{
          history.push('/');
        }
      }else{
        setNotification(response.data.message)
      }
    })
    .catch(function (error) {
      setNotification(error.message)
    })
    window.hLoader();
  }
  return (
    <>
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={6} lg={5} xl={4}>
              <div className="card overflow-hidden">
                {/* <div className="bg-login text-center">
                  <div className="bg-login-overlay"></div>
                  <div className="position-relative">
                    <h5 className="text-white font-size-20">Welcome Back !</h5>
                    <p className="text-white-50 mb-0">Sign in to continue to Sus-Plan.</p>
                    <Link to="/" className="logo logo-admin mt-4">
                      <img src={icon} alt="" height="30" />
                    </Link>
                  </div>
                </div> */}
                <div className='row' style={{paddingTop:"2.5rem"}}>
                  <div className='col-md-12' style={{textAlign:"center"}}>
                      <img src={logo} alt="" height="80" />
                  </div>
                </div>
                <div className="card-body pt-1">
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      {username && password ? (
                        <Alert color="success">Your Login Credentials,<br/>Username: <b>{username}</b><br/>Password: <b>{password}</b></Alert>
                      ) : null}

                      {notification && typeof notification === "string" ? (
                        <Alert color="danger">{notification}</Alert>
                      ) : null}
                      <div className="mb-3">
                        <AvField
                          name="username"
                          defaultValue={username}
                          label="Username"
                          value=""
                          className="form-control"
                          placeholder="Enter username"
                          type="text"
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="password"
                          defaultValue={password}
                          label="Password"
                          value=""
                          type="password"
                          required
                          placeholder="Enter Password"
                        />
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                        style={{marginTop:"0"}}
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      {/* <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted"><i
                          className="mdi mdi-lock me-1"></i> Forgot your password?</Link>
                      </div> */}
                    </AvForm>

                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                {/* <p>Don't have an account ? <Link to="/register"
                  className="fw-medium text-primary"> Signup now </Link> </p> */}
                <p>
                  © {new Date().getFullYear()} Powered by {Config.applicationInfo.appName}
                  <br/> Developed by <a href={Config.applicationInfo.devOrgLink} target="_blank"><span style={{color: "#fd7014"}}>{Config.applicationInfo.devOrgName}</span></a>
                  {/* © {new Date().getFullYear()} PGDSCM, BIM <br/> Powered by <a href={Config.applicationInfo.devOrgLink} target="_blank"><span style={{color: "#fd7014"}}>{Config.applicationInfo.devOrgName}</span></a> */}
                </p>
              </div>
            </Col>
          </Row>

        </Container>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func
}